export default "__VITE_ASSET__z8_dDIx1__"